var md = require("markdown-it")({
  html: true,
  breaks: true,
  linkify: true
}).use(require("markdown-it-ins"))

export default md



// WEBPACK FOOTER //
// ./webapp/scripts/markdown.js